export {
  QUERY as GetChannelsQuery,
  subscriber,
  useGetChannels,
} from "./GetChannels";
